var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"koko"},[_c('line-chart-component',{staticClass:"koko",attrs:{"chartOptions":_vm.chartOptions,"chartData":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }